import { render, staticRenderFns } from "./PopupGHSPictogramRescan.vue?vue&type=template&id=61f810a4&scoped=true"
import script from "./PopupGHSPictogramRescan.vue?vue&type=script&lang=js"
export * from "./PopupGHSPictogramRescan.vue?vue&type=script&lang=js"
import style0 from "./PopupGHSPictogramRescan.vue?vue&type=style&index=0&id=61f810a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f810a4",
  null
  
)

export default component.exports